/*
 * @Description: 
 * @Author: yanpin
 * @Date: 2020-11-26 18:20:45
 * @LastEditTime: 2021-06-30 14:15:09
 * @LastEditors: zhengfan
 */
import React, { useState, useContext, useEffect } from 'react'
import { Nav, CascaderSelect } from '@alifd/next'
import { Link } from 'react-router-dom'
import '../style/sidebar.scss'
import { OverallContext, SET_SELECTED_SELLER } from '../store/overallStore'
import { withRouter } from 'react-router'
import { getRole, getDepartment} from '../common/session'
import { ADMIN, LEADER } from '../constants/constants'
import userApi from '../api/userApi'

function SideBar() {
    const role = JSON.parse(getRole() || '[]')
    const department = getDepartment()
    const [selectData, setSelectData] = useState([])
    const { overallInfo, dispatch } = useContext(OverallContext);

    useEffect(() => {
        userApi.loadDepartments({ group_id: department }).then(res => {
            let newData = res?.data?.map(item => {
                item.label = item.name
                item.value = item.id
                return item
            })
            setSelectData(newData)
        })
    }, [])

    const navInfo = [
        {
            label: '运营指标',
            items: [
                { link: "/total-state", name: '总状态' },
                { link: "/total-trend", name: '总趋势' },
                { link: "/hospital-model", name: '医院模型' },
                { link: "/abnormal-analysis", name: '异常与分析' },
                { link: "/growth-analysis", name: '增长与分析' },
                { link: "/activation", name: '活跃度' }
            ]
        },
        {
            allowedRoles: [ADMIN,LEADER],
            label:'销售排名',
            items: [
                {link: "/sales-rank", name:'销售排名'}
            ]
        },
        {
            // allowedRoles: [ADMIN, LEADER],
            label: '元数据',
            items: [
                { link: "/hospitalCards", name: '医院卡片' },
                { link: "/robotData", name: '机器人卡片' },
                { link: "/notDeploying-robotData", name: '未部署机器人卡片' }
            ]
        },
        {
            allowedRoles: [ADMIN],
            label: '管理员',
            items: [
                { link: "/user-setting", name: '账号管理' },
                { link: "/index-dispose", name: '指标配置' },
                { link: "/user-record", name: '用户登录日志' },
            ]
        },
        {
            label:'医院报表导出',
            link: "/hospital-report"
        },
        {
            label:'物流数据',
            link: "/logistics-analysis"
        },
        {
            label:'仓储数据',
            link: "/warehouseData"
        },
        {
            label:'行为管理数据',
            link: "/behavior-management-data"
        },
        {
            label:'运营排名',
            link: "/operational-ranking"
        }
    ]

    const changeStaff = async (val, data) => {
        let selectedStaff = data.selectedSeller || data.user_id;
        await userApi.setStaff({ staff: selectedStaff })
        dispatch({
            type: SET_SELECTED_SELLER,
            payload: { selectedSeller: selectedStaff, role: JSON.parse(data.role || '[]') }
        })
    }
    

    const onLoadPersonnel = (data) => {
        if (!data.id) { return }
        return new Promise((resolve, reject) => {
            userApi.loadPersonnel({ group_id: data.id }).then(res => {
                let newData = selectData.map(item => {
                    if (item.id === data.id) {
                        item.children = res?.data.map(subItem => {
                            subItem.label = subItem.user_name
                            subItem.value = subItem.user_id
                            subItem.isLeaf = true
                            return subItem
                        })
                        item.children.unshift({ label: '全部', value: data.label, selectedSeller: data.id, isLeaf: true })
                    }
                    return item
                })
                setSelectData(newData)
                resolve();
            })
        });        
    }

    return (
        <Nav
            style={{ boxShadow: 'none', border: 'none' }}
            defaultOpenAll
            iconOnly={false}
            hasArrow={true}
            hasTooltip={true}
            embeddable={false}
            openMode='single'
        >
            <div className="nav-header">运营系统</div>
            {
                [ADMIN, LEADER].some(item => role.includes(item)) &&
                <CascaderSelect
                    dataSource={selectData}
                    loadData={onLoadPersonnel}
                    onChange={changeStaff}
                    style={{ display: 'block', width: 135, margin: '0 auto' }}
                />
            }
            {
                navInfo.map((sub) => {
                    if (!sub.allowedRoles || sub.allowedRoles.some(item => role.includes(item))) {
                        if(sub.items){
                            return (
                                <Nav.SubNav label={sub.label} key={sub.label}>
                                    {
                                        sub.items.map(item => {
                                            if (!item.allowedRoles || item.allowedRoles.some(item => role.includes(item))) {
                                                return (
                                                    <Nav.Item key={item.link}>
                                                        <Link to={item.link}>{item.name}</Link>
                                                    </Nav.Item>
                                                )
                                            }
                                        }
                                        )
                                    }
                                </Nav.SubNav>
                            )
                        } else {
                            return (
                                <Nav.Item key={sub.link}>
                                    <Link to={sub.link}>{sub.label}</Link>
                                </Nav.Item>
                            )
                        }
                    }
                }
                )
            }
        </Nav>
    )
}

export default withRouter(SideBar);